import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EmployeeBudgetFilter } from '@flexyoo/employee/models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'flexyoo-employee-budget-list-filter',
  templateUrl: 'employee-budget-list-filter.component.html',
  styleUrls: ['./employee-budget-list-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    TranslateModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class EmployeeBudgetListFilterComponent {
  years = input<number[]>([]);

  yearItems = computed(() => {
    const years = this.years() || [];
    const items = years.map((y) => ({ key: y, label: y }));
    return [{ key: null, label: 'general.all' }, ...items];
  });

  applyFilter = output<EmployeeBudgetFilter>();
  clearFilter = output();

  readonly form = inject(FormBuilder).group({
    year: [null],
  });

  constructor() {
    const valueChanged = toSignal(this.form.valueChanges);
    effect(() => {
      const val = valueChanged();
      if (val) {
        this.applyFilter.emit({ year: +val.year || undefined });
      }
    });
  }
}
